import React from "react";
//import About from "./page/about/About";
//import Contact from "./page/contact/contact";
import { BrowserRouter as Router ,Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./page/Home";
import Shareholding from "./page/Shareholding";
import Annualsecretaria from "./page/Annualsecretaria";
import Corporate from "./page/Corporate";
import Disclosures from "./page/Disclosures";
import Otherfilings from "./page/Otherfilings";
import Integratedgovernance from "./page/Integratedgovernance";
import Integratedfinancial from "./page/Integratedfinancial";
import Integratedfilling from "./page/Integratedfilling";
import Financial from "./page/Financial";
import Regulation30 from "./page/Regulation30";
import Annualgeneralmeeting from "./page/Annualgeneralmeeting";
import Committees from "./page/Committees";
import Intimation from "./page/Intimation";
import Outcomeofboardmeeting from "./page/Outcomeofboardmeeting";
import Boardofdirector from "./page/Boardofdirector";
import Annual_reports from "./page/Annual_reports";
import Annual_return from "./page/Annual_return";
import Ishantmalhotra from "./page/Ishantmalhotra";
import Msshruti from "./page/Msshruti";
import Mrlovekumar from "./page/Mrlovekumar";
import Mrshivamkumar from "./page/Mrshivamkumar";
import Moa_aoa from "./page/Moa_aoa";
import About from "./page/About";
import Investor from "./page/Investor";
import Policies from "./page/Policies";
import Contact from "./page/Contact";
import Noticeofbm from "./page/Noticeofbm";
import Press_release from "./page/Press_release";

function App() {
  return (
    <div>
	<Router>
      <NavBar />
	    <Routes>
		  <Route path="/" element={<Home />} />
		  <Route path="/about" element={<About />} />
		  <Route path="/investor-relation" element={<Investor />} />
		  <Route path="/annual-secretarial-compliance-report" element={<Annualsecretaria />} />
		  <Route path="/corporate-governance" element={<Corporate />} />
		  <Route path="/integrated-governance" element={<Integratedgovernance />} />
		  <Route path="/integrated-financial" element={<Integratedfinancial />} />
		  <Route path="/integrated-filling" element={<Integratedfilling />} />
		  <Route path="/disclosures-under-regulation" element={<Disclosures />} />
		  <Route path="/other-filings-with-stock-exchange" element={<Otherfilings />} />
		  <Route path="/financial-result" element={<Financial />} />
		  <Route path="/regulation-30" element={<Regulation30 />} />
		  <Route path="/annual-general-meeting" element={<Annualgeneralmeeting />} />
		  <Route path="/committees-of-board" element={<Committees />} />
		  <Route path="/intimation" element={<Intimation />} />
		  <Route path="/outcome-of-board-meeting" element={<Outcomeofboardmeeting />} />
		  <Route path="/board-of-director" element={<Boardofdirector />} />
		  <Route path="/annual-reports" element={<Annual_reports />} />
		  <Route path="/annual-return" element={<Annual_return />} />
		  <Route path="/moa-aoa" element={<Moa_aoa />} />
		  <Route path="/shareholding-pattern" element={<Shareholding />} />
		  <Route path="/codes-policies" element={<Policies />} />
		  <Route path="/mr-ishant-malhotra" element={<Ishantmalhotra />} />
		  <Route path="/ms-shruti" element={<Msshruti />} />
		  <Route path="/mr-hemant" element={<Mrlovekumar />} />
		  <Route path="/mrs-geetika-chawla" element={<Mrshivamkumar />} />
		  <Route path="/contact" element={<Contact />} />
		  <Route path="/notice-of-board-meeting" element={<Noticeofbm />} />
		  <Route path="/press-release-&-announcement" element={<Press_release />} />
		</Routes>
      <Footer />
	 </Router>

    </div>
  );
}

export default App;